import App from './App.svelte';

const app = new App({
	target: document.getElementById('calcWidget')
});

export default app;